import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PremiumHome from './pages/PremiumHome';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PremiumHome />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;